import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnProps, defaultColumnProps } from "../../../../DataTable/ColumnProps";

// We want to highlight packages that skip ahead in the package number sequence
function PackageNumberColumn({ width }: ColumnProps = defaultColumnProps) {
    const { t } = useTranslation();

    return {
        Header: t<string>('LotDetails.Packages.BoxNumber'),
        accessor: 'containerNumber',
        filter: 'includesString',
        Cell: (props: any) => {
            const orderedRows = props.rows.sort((r: any) => r.original.containerNumber);
            const thisRowIndex = orderedRows.findIndex((r: any) => r.original.containerNumber === props.value);
            let emphasisValue = false;
            if (thisRowIndex > 0) {
                const previousContainerNumber = orderedRows[thisRowIndex - 1].original.containerNumber;
                // The last few characters of container numbers represent the container # 
                // The first few characters represent the date of production and aren't always numeric, so we can't use them for this comparison
                const numericSuffixLength = 4;
                const previousNumericContainerNumber = previousContainerNumber.substring(previousContainerNumber.length - numericSuffixLength);
                const currentNumericContainerNumber = props.value.substring(props.value.length - numericSuffixLength);
                emphasisValue = +previousNumericContainerNumber !== +currentNumericContainerNumber - 1;
            }

            return (
                <div>
                    {emphasisValue
                        ? <strong>{props.value}</strong>
                        : props.value}
                </div>
            );
        },
        width: width
    };
}

export default PackageNumberColumn;